/**
 * Created by hp on 2017/8/21.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {WKError} from '../../components';
import {WKPreload, WKNoData, WKInfiniteScroll} from '../../components/wk';
import {RelaySettingTopBar, RelaySettingListItem} from '../relaySetting';
import errorImg from '../../images/no-source.png'


class RelaySettingChannelList extends Component {
    constructor() {
        super();
        this.handleMore = this.handleMore.bind(this);
        this.handleLoadData = this.handleLoadData.bind(this);
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.handleLoadData();
    }

    handleMore() {
        const {has_more, next_offset} = this.props.relaySetting;
        if (has_more) {
            this.handleLoadData(next_offset);
        }
    }

    handleLoadData(nextOffset) {
        const {id} = this.props.relaySetting;

        this.setState({
            loading: true
        });

        nextOffset = nextOffset ? nextOffset : 0;
        axios.get(`/api/relay/channel/${id}/relaiers?offset=${nextOffset}`).then((res) => {
            if (res.data.code === 0) {
                this.setState({
                    loading: false
                });
                if (nextOffset) {
                    this.props.dispatch({type: 'RELAY_SETTING_LIST_DATA_MORE', payload: res.data.data});
                } else {
                    this.props.dispatch({type: 'RELAY_SETTING_LIST_DATA_INIT', payload: res.data.data});
                }
            }
        }).catch(error => {
            console.log(error);
            let payload = {
                tips: '你不是管理员。',
                img: errorImg,
                href: '/',
                btn: '回到首页'
            };

            if (error.response && error.response.status === 404) {
                payload = {
                    tips: '访问的页面不存在。',
                    img: errorImg,
                    href: '/',
                    btn: '回到首页'
                }
            }
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload
            })
        });
    }

    render() {
        const {middleInitialized, relaiers, has_more, loading} = this.props.relaySetting;
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="relay-setting-channel-list">
                    <WKError />
                </div>
            )
        }

        if (!middleInitialized) {
            return <WKPreload />
        }

        return (
            <div className="relay-setting-channel-list">
                <RelaySettingTopBar />

                {relaiers.length > 0 ?
                    relaiers.map((item, index) => (
                        <RelaySettingListItem key={item.id} relayer={item} isEnd={index + 1 === relaiers.length} relayType="channel"/>
                    ))
                    :
                    <WKNoData text="暂无转载者"/>
                }

                <WKInfiniteScroll onTouchBottom={this.handleMore} isKill={!has_more} isShowLoading={relaiers && relaiers.length > 0} isStop={loading}/>
            </div>
        )
    }
}

export default connect((state) => ({
    relaySetting: state.relaySetting,
    error: state.error,
}))(RelaySettingChannelList);



// WEBPACK FOOTER //
// ./src/components/relaySetting/RelaySettingChannelList.js